<template>
  <AppLargeFooter v-if="size === 'large'" :fragment="fragment" />
  <AppSmallFooter v-else-if="size === 'small'" />
</template>

<script setup lang="ts">
import { type AppFooterFragment } from './AppFooter.generated'
import AppLargeFooter from './AppLargeFooter.vue'
import AppSmallFooter from './AppSmallFooter.vue'

withDefaults(
  defineProps<{
    fragment?: AppFooterFragment
    size?: 'small' | 'large'
  }>(),
  {
    size: 'large',
  }
)
</script>
